import React from 'react'
import Layout from '../layouts/index.js'
import Contact from '../components/contact/contact.js'
import ImageSlider from '../components/hero/index'

function importAll(r) {
  return r.keys().map(r)
}

const images = importAll(
  require.context(
    '../images/wild-posters-page',
    false,
    /\.(png|jpe?g)$/ // png, jpg, jpeg
  )
)

class LunchTruckPage extends React.Component {
  render() {
    return (
      <Layout head={{ title: 'Wild Posters' }}>
        <section id="title">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <h1 className="heading-title">Wild Posters</h1>
              </div>
            </div>
          </div>
        </section>

        <section id="wild-posters" className="text-center">
          <div className="container">
            <div className="row">
              <div className="col">
                <div
                  className="mb-5 "
                  style={{ maxWidth: '800px', margin: '0 auto' }}
                >
                  <p className="section-p font-weight-bold">Wild Postings</p>
                  <p className="section-p">
                    We operate in every major market! Below is an overview of
                    how it works.
                  </p>
                  <p className="section-p font-weight-bold">Overview</p>
                  <p className="section-p">
                    All wild poster walls can average 2 to 10 (24"W x 36"H) or
                    48” W x 72’H posters per location. Includes refresh every 72
                    hours copy change at two weeks. Teaser then reveal. Client
                    can choose size.
                  </p>
                </div>
                <div className="container" style={{ maxWidth: '1800px' }}>
                  <div className="carousel-container">
                    <ImageSlider images={images} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Contact />
      </Layout>
    )
  }
}
export default LunchTruckPage
